import { ArrowLeft01FreeIcons } from '@hugeicons/core-free-icons';
import { HugeiconsIcon } from '@hugeicons/react';
import { RegisteredRouter, useCanGoBack, useNavigate, useRouter, ValidateLinkOptions } from '@tanstack/react-router';
import { NActionIcon, NButton, NButtonProps } from '@next-is-free-monorepo/nif-web-components';
import clsx from 'clsx';

export interface BackButtonProps<
  TRouter extends RegisteredRouter = RegisteredRouter,
> {
  className?: string;
  fallBackRouteOptions: ValidateLinkOptions<TRouter>;
  hideText?: boolean;
}

const BackButton = ({ className, fallBackRouteOptions, hideText }: BackButtonProps) => {

  const router = useRouter();
  const canGoBack = useCanGoBack();
  const navigate = useNavigate();

  return (
    <button onClick={() => canGoBack ? router.history.back() : navigate(fallBackRouteOptions)}
            className={clsx('flex items-center gap-1 py-2 px-4 bg-slate-100 rounded-2xl hover:bg-slate-200', className)}>
      <HugeiconsIcon className={`relative ${!hideText && '-left-1'}`} size={16}
                     icon={ArrowLeft01FreeIcons} /> {!hideText && 'Indietro'}
    </button>
  );
};
export default BackButton;
